/**
 * Ghost Cable brand assets: the hexagon ghost-and-cable logo in every size the site needs.
 * Hosted on a long-cache CDN; `/favicon.svg` in public/ is the same-origin fallback.
 * The app (PWA) icons live in public/manifest.json too; keep both lists in step.
 */

const CDN = 'https://storage.googleapis.com/runable-templates/cli-uploads%2F862FaBd7TiOoyulTXT89vl6hjYI5AtMg%2F';

export const BRAND_COLOR = '#07060c';

export const LOGO = {
  /** 32 px favicon. */
  favicon: `${CDN}eA3PZIGug6Wqu2Sb1fObL%2Ff32.png`,
  /** 64 px, sharp at 32 px on high-density screens (header and sidebar mark). */
  mark: `${CDN}VQGm8qZWo-fhfbpgEs119%2Ff64.png`,
  /** 180 px, logo on the dark tile, for iOS home screens. */
  apple: `${CDN}3HbRgcVlvOjihJyGEbDjt%2Fapple-touch-icon.png`,
  /** App icons: the logo on a transparent background. */
  icon192: `${CDN}VyfcD-6oQDqhw8CpbNyDd%2Ficon-192.png`,
  icon512: `${CDN}DyQ--fNwFSEJL4pWO-4K9%2Ficon-512.png`,
  /** Android adaptive icons: the logo inside the safe circle on the dark tile. */
  maskable192: `${CDN}ExDhijVaRCT31iL79FBM3%2Fmaskable-192.png`,
  maskable512: `${CDN}8Nk1XWl3ggyfnM1wAzrQE%2Fmaskable-512.png`,
};

/** 1200 x 630 share card for link previews. */
export const SHARE_IMAGE = {
  url: `${CDN}s2FRxDMRNu7IT436bLR-S%2Fog-image.jpg`,
  width: 1200,
  height: 630,
  alt: 'Ghost Cable logo, a ghost wrapped in a power cable, with the line "Television that refuses to die."',
};
